import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import _ from 'lodash';
import { ProjectStreamService } from 'src/app/shared/common/current-project/project-stream.service';
import { SurveyJob } from 'src/app/shared/survey-data-services/survey-job';
import { User } from 'src/app/shared/user/user';

@Component({
    selector: 'edit-job-assigned-user',
    templateUrl: './edit-job-assigned-user.component.html'
})
export class EditJobAssignedUserComponent implements OnInit {
    private _job: SurveyJob = new SurveyJob({ assignees: [] });

    @Input()
    set job(value: SurveyJob) {
        this._job = _.cloneDeep(value);
    }
    get job(): SurveyJob {
        return this._job;
    }

    @Output() userChange = new EventEmitter<Array<User>>();

    currentProjectUsers: any[] = [];
    connectTags: string[] = [];

    constructor(private projectStream: ProjectStreamService) {}

    ngOnInit(): void {
        this.loadProjectUsers();
    }

    async loadProjectUsers(): Promise<void> {
        this.currentProjectUsers = await this.projectStream.getCurrentProjectUsers();
    }

    onUserChange(selectedUsers: Array<User>): void {
        this.job.assignees = selectedUsers;
        this.userChange.emit(selectedUsers);
    }

    onUserDelete(user: User): void {
        this.job.assignees = [];
        this.userChange.emit([]);
    }
}
